class RFQController {
  constructor() {
    this.data = this.loadData();
    if (!this.data) return;

    this.customer = this.data.customer;
    this.product = this.data.product;
    this.settings = this.data.settings;
    this.currentVariantId = this.resolveInitialVariant();
    this.cotizarLabel = this.settings.cotizar_label || 'Cotizar';
    this.reapplyFrame = null;
    this.pendingVariantId = null;

    this.selectors = {
      rfqButton: '.rfq-btn',
      quoteRoot: '[data-pq-product]',
      atcWrapper: 'add-to-cart-component',
      nativeAtcButton: 'add-to-cart-component button[name="add"]:not(.rfq-btn)',
      variantInput: 'input[name="id"]',
      priceTargets: 'product-price, .sticky-add-to-cart__price',
    };

    this.init();
  }

  loadData() {
    const el = document.getElementById('rfq-controller-data');
    if (!el) {
      console.warn('[RFQ Controller] No se encontró el elemento de datos.');
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('[RFQ Controller] Error parseando datos:', error);
      return null;
    }
  }

  resolveInitialVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = Number(urlParams.get('variant'));
    if (fromUrl && this.getVariantById(fromUrl)) return fromUrl;
    return this.product.variants[0]?.id;
  }

  getVariantById(id) {
    const numericId = Number(id);
    if (!numericId) return undefined;
    return this.product.variants.find((variant) => variant.id === numericId);
  }

  evaluate(variantId) {
    const variant = this.getVariantById(variantId) || this.product.variants[0];
    const { customer, product, settings } = this;

    if (!customer.logged_in) {
      return this.buildResult(true, false, false, 'R1');
    }

    if (!customer.has_company) {
      return this.buildResult(true, false, false, 'R2');
    }

    if (!variant.available) {
      return this.buildResult(settings.sold_out_show_cotizar, false, true, 'R3');
    }

    if (!variant.sku || variant.sku.trim() === '') {
      return this.buildResult(true, false, false, 'R4');
    }

    if (variant.price === 0) {
      return this.buildResult(true, false, false, 'R5');
    }

    if (settings.price_threshold > 0 && variant.price >= settings.price_threshold) {
      return this.buildResult(true, false, false, 'R6');
    }

    if (customer.has_company && product.tags.includes(settings.cotizar_tag)) {
      return this.buildResult(true, false, false, 'R7');
    }

    return this.buildResult(false, true, false, 'R0');
  }

  buildResult(showCotizar, showATC, showSoldOut, ruleName) {
    return {
      showCotizar,
      showATC,
      showSoldOut,
      hidePrice: showCotizar,
      ruleName,
    };
  }

  getButtonLabel(button) {
    if (!button) return '';

    const nested = button.querySelector('.add-to-cart-text__content span span');
    if (nested?.textContent?.trim()) return nested.textContent.trim();

    const text = button.querySelector('.add-to-cart-text');
    return text?.textContent?.trim() || '';
  }

  setButtonLabel(button, label) {
    const nested = button.querySelector('.add-to-cart-text__content span span');
    if (nested) {
      nested.textContent = label;
      return;
    }

    const text = button.querySelector('.add-to-cart-text');
    if (text) text.textContent = label;
  }

  captureCotizarLabel() {
    const rfqButton = document.querySelector(this.selectors.rfqButton);
    const label = this.getButtonLabel(rfqButton);
    if (label) this.cotizarLabel = label;
  }

  styleRfqButton(button) {
    if (!button) return;

    button.classList.remove('add-to-cart-button');
    button.classList.add('rfq-controller__button', 'button', 'button-secondary');
    button.removeAttribute('ref');
    button.removeAttribute('on:click');
    button.setAttribute('data-rfq-button', 'true');
    button.setAttribute('data-puppet', 'true');
    button.setAttribute('data-testid', 'rfq-cotizar-button');
    button.type = 'button';
    button.removeAttribute('name');

    button.querySelectorAll('.add-to-cart-icon, .add-to-cart__added').forEach((element) => {
      element.setAttribute('aria-hidden', 'true');
      element.hidden = true;
    });

    button.removeAttribute('data-added');
  }

  ensureNativeAtcButton(wrapper) {
    if (!wrapper) return null;

    const rfqButtons = wrapper.querySelectorAll('.rfq-btn, [data-rfq-button]');
    rfqButtons.forEach((button) => this.styleRfqButton(button));

    const nativeButton = wrapper.querySelector(
      'button[type="submit"][name="add"]:not(.rfq-btn):not([data-rfq-button])'
    );

    if (!nativeButton) return null;

    nativeButton.setAttribute('ref', 'addToCartButton');
    nativeButton.classList.add('add-to-cart-button');
    nativeButton.removeAttribute('data-rfq-button');
    nativeButton.removeAttribute('data-puppet');

    rfqButtons.forEach((button) => {
      button.removeAttribute('ref');
    });

    return nativeButton;
  }

  syncRfqButtons() {
    const label = this.cotizarLabel;

    document.querySelectorAll(this.selectors.rfqButton).forEach((button) => {
      this.styleRfqButton(button);

      if (this.getButtonLabel(button) !== label) {
        this.setButtonLabel(button, label);
      }
    });
  }

  applyPriceVisibility(hidePrice) {
    document.querySelectorAll(this.selectors.priceTargets).forEach((element) => {
      element.classList.toggle('visually-hidden', hidePrice);
      element.hidden = hidePrice;
      element.setAttribute('aria-hidden', hidePrice ? 'true' : 'false');
    });
  }

  applyVisibility(result) {
    const { showCotizar, showATC, showSoldOut, hidePrice, ruleName } = result;

    document.querySelectorAll(this.selectors.atcWrapper).forEach((wrapper) => {
      this.ensureNativeAtcButton(wrapper);
    });

    document.querySelectorAll(this.selectors.quoteRoot).forEach((root) => {
      root.hidden = !showCotizar;
    });

    document.querySelectorAll(this.selectors.rfqButton).forEach((button) => {
      this.styleRfqButton(button);
      button.style.display = showCotizar ? '' : 'none';
      button.hidden = !showCotizar;
      button.setAttribute('aria-hidden', showCotizar ? 'false' : 'true');
    });

    document.querySelectorAll(this.selectors.atcWrapper).forEach((wrapper) => {
      wrapper.style.display = '';

      wrapper.querySelectorAll('button[name="add"]').forEach((button) => {
        if (button.classList.contains('rfq-btn')) return;

        if (showSoldOut) {
          button.style.display = '';
        } else {
          button.style.display = showATC ? '' : 'none';
        }
      });
    });

    document.querySelectorAll(this.selectors.nativeAtcButton).forEach((button) => {
      if (showSoldOut) {
        button.style.display = '';
      } else {
        button.style.display = showATC ? '' : 'none';
      }
    });

    const stickyButton = document.querySelector('.sticky-add-to-cart__button');
    if (stickyButton) {
      if (showSoldOut) {
        stickyButton.style.display = '';
      } else {
        stickyButton.style.display = showATC ? '' : 'none';
      }
    }

    if (showCotizar) {
      this.syncRfqButtons();
    }

    this.applyPriceVisibility(hidePrice);

    if (this.settings.debug_mode) {
      const variant = this.getVariantById(this.currentVariantId);
      console.log('[RFQ Controller] Evaluación:', {
        regla: ruleName,
        variantId: this.currentVariantId,
        variantSku: variant?.sku,
        variantPrice: variant?.price,
        priceThreshold: this.settings.price_threshold,
        variantAvailable: variant?.available,
        customer: {
          logged_in: this.customer.logged_in,
          has_company: this.customer.has_company,
        },
        result,
        hidePrice,
        rfqButtonLabels: [...document.querySelectorAll(this.selectors.rfqButton)].map((button) =>
          this.getButtonLabel(button)
        ),
      });
    }
  }

  scheduleReapply(variantId) {
    const id = Number(variantId);
    if (!id) return;

    this.pendingVariantId = id;

    if (this.reapplyFrame) {
      cancelAnimationFrame(this.reapplyFrame);
    }

    // product-form.js hace morph del botón en el mismo tick de variant:update.
    // Doble rAF garantiza ejecutar después de que el tema actualice el DOM.
    this.reapplyFrame = requestAnimationFrame(() => {
      this.reapplyFrame = requestAnimationFrame(() => {
        this.currentVariantId = this.pendingVariantId;
        this.applyVisibility(this.evaluate(this.currentVariantId));
      });
    });
  }

  listenVariantChanges() {
    document.addEventListener('variant:update', (event) => {
      this.scheduleReapply(event.detail?.resource?.id);
    });

    document.addEventListener('variant:changed', (event) => {
      this.scheduleReapply(event.detail?.variant?.id);
    });

    const variantInput = document.querySelector(this.selectors.variantInput);
    if (!variantInput) return;

    const onInputChange = () => this.scheduleReapply(variantInput.value);

    new MutationObserver(onInputChange).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value'],
    });

    variantInput.addEventListener('change', onInputChange);

    document.addEventListener('cart:update', () => {
      document.querySelectorAll(this.selectors.rfqButton).forEach((button) => {
        button.removeAttribute('data-added');
      });
    });
  }

  observeButtonMorph() {
    let morphTimer = null;

    const observer = new MutationObserver(() => {
      if (morphTimer) clearTimeout(morphTimer);
      morphTimer = setTimeout(() => {
        const result = this.evaluate(this.currentVariantId);
        this.applyVisibility(result);
      }, 0);
    });

    document.querySelectorAll(this.selectors.atcWrapper).forEach((wrapper) => {
      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    });
  }

  waitForQuoteButton(callback) {
    const maxAttempts = 50;
    let attempts = 0;

    const interval = setInterval(() => {
      attempts += 1;
      const rfqBtn =
        document.querySelector(this.selectors.rfqButton) ||
        document.querySelector(this.selectors.quoteRoot);

      if (rfqBtn || attempts >= maxAttempts) {
        clearInterval(interval);

        if (!rfqBtn && this.settings.debug_mode) {
          console.warn(
            '[RFQ Controller] Botón Cotizar no encontrado después de 5s. Aplicando solo reglas de ATC.'
          );
        }

        callback();
      }
    }, 100);
  }

  init() {
    this.waitForQuoteButton(() => {
      this.captureCotizarLabel();
      this.applyVisibility(this.evaluate(this.currentVariantId));
      this.listenVariantChanges();
      this.observeButtonMorph();

      const resyncObserver = new MutationObserver((mutations) => {
        const rfqAdded = mutations.some((mutation) =>
          [...mutation.addedNodes].some(
            (node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches?.('.rfq-btn, [data-pq-product]') ||
                node.querySelector?.('.rfq-btn, [data-pq-product]'))
          )
        );

        if (rfqAdded) {
          this.captureCotizarLabel();
          this.applyVisibility(this.evaluate(this.currentVariantId));
        }
      });

      const productForm = document.querySelector(
        'product-form-component, .product-form-buttons, .buy-buttons-block'
      );
      if (productForm) {
        resyncObserver.observe(productForm, { childList: true, subtree: true });
      }
    });
  }
}

if (document.getElementById('rfq-controller-data')) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new RFQController());
  } else {
    new RFQController();
  }
}
